// extracted by mini-css-extract-plugin
export var sliderRange = "_oy-2";
export var sliderRoot = "_oy-0";
export var sliderThumb = "_oy-3";
export var sliderTrack = "_oy-1";